/** Hierarchical TanStack Query keys — one place so invalidation is predictable. */
export const qk = {
  me: () => ['me'] as const,
  meSettings: () => ['me', 'settings'] as const,
  cities: (q?: string) => ['cities', q ?? ''] as const,
  city: (slug: string) => ['cities', 'detail', slug] as const,
  places: (params: Record<string, unknown>) => ['places', params] as const,
  place: (id: string) => ['places', 'detail', id] as const,
  placeInsights: (id: string, lang: string) => ['places', 'detail', id, 'insights', lang] as const,
  hotels: (params: Record<string, unknown>) => ['hotels', params] as const,
  reviews: (placeId: string, params?: Record<string, unknown>) => ['reviews', placeId, params ?? {}] as const,
  trips: (status?: string) => ['trips', status ?? 'all'] as const,
  trip: (id: string) => ['trips', 'detail', id] as const,
  tripBudget: (id: string) => ['trips', 'detail', id, 'budget'] as const,
  segments: (scope?: string) => ['segments', scope ?? 'upcoming'] as const,
  segment: (id: string) => ['segments', 'detail', id] as const,
  segmentTimeline: (id: string) => ['segments', 'detail', id, 'timeline'] as const,
  segmentForecast: (id: string) => ['segments', 'detail', id, 'forecast'] as const,
  travelStats: () => ['segments', 'stats'] as const,
  segmentRoute: (id: string) => ['segments', 'detail', id, 'route'] as const,
  services: (params: Record<string, unknown>) => ['services', params] as const,
  search: (q: string, params?: Record<string, unknown>) => ['search', q, params ?? {}] as const,
  notifications: () => ['notifications'] as const,
  unread: () => ['notifications', 'unread'] as const,
  favorites: () => ['me', 'favorites'] as const,
};
